import * as firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
	apiKey: "AIzaSyAKN0Q_QzPgUGv2b8VOlapcUaNru-5TRKw",
	authDomain: "satendra-portfolio.firebaseapp.com",
	databaseURL: "https://satendra-portfolio.firebaseio.com",
	projectId: "satendra-portfolio",
	storageBucket: "satendra-portfolio.appspot.com",
	messagingSenderId: "1044524342739",
	appId: "1:1044524342739:web:d6399a36e38d3fa77ca326",
	measurementId: "G-KZQKZ5EE6E"
};

export const app = firebase.initializeApp(firebaseConfig);
export const db = firebase.firestore();



